import { Text } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

interface SectionsStateMessageProps {
  isLoading: boolean
  isError: boolean
  className?: string
  emptyMessageKey?: 'files.emptySections' | 'files.emptySectionsView' | 'files.emptyTablesView'
}

export const SectionsStateMessage = ({
  isLoading,
  isError,
  className,
  emptyMessageKey = 'files.emptySections',
}: SectionsStateMessageProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <Text className={className}>{t('files.loadingSections')}</Text>
  } else if (isError) {
    return <Text className={className}>{t('files.errorLoadingSections')}</Text>
  } else {
    return <Text className={className}>{t(emptyMessageKey)}</Text>
  }
}
